<template>
    <h1 class="title is-5 align-center">
        Registration List
    </h1>
    <base-spinner v-if="isLoading"></base-spinner>
    <div v-if="!!error" class="notification is-danger">
        <p>{{ error }}</p>
    </div>
    <div v-if="registrationList" class="block">
        <h1 class="title is-6">Total registrations: {{ registrationList.length }}</h1>

        <table class="table is-fullwidth">
            <thead>
                <tr>
                    <th>
                        ID
                    </th>
                    <th>
                        Child's name
                    </th>
                    <th>
                        Gender
                    </th>
                    <th>
                        YOB
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr @click="handleRowClick(registered.id, registered.note, registered.name)" v-for="registered in registrationList" :key="registered.id">
                    <td>
                        {{ registered.beneficiaryID }}
                    </td>
                    <td>
                        {{ registered.note }}
                    </td>
                     <td>
                        {{ registered.gender }}
                    </td>
                     <td>
                        {{ registered.yearOfBirth }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="modal" :class="[showUpdateNote ? 'is-active' : '']">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Update Note</p>
                <button class="delete" aria-label="close" @click="toggleUpdateNote"></button>
            </header>
            <section class="modal-card-body">
                <UpdateNote :eventID="this.id" :beneficiaryID="this.selectedID" :note="this.selectedNote" :beneficiaryName="this.selectedBeneficiaryName"></UpdateNote>
            </section>
        </div>
    </div>
    
    <div class="align-center">
        <div class="button is-info is-rounded" @click="loadRegistrations()">
            Load / Refresh
        </div>
    </div>
</template>

<script>
import UpdateNote from './UpdateNote.vue';

export default {
    components: {
        UpdateNote
    },
    props: {
        id: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            isLoading: false,
            error: null,
            showUpdateNote: false,
            selectedID: 0,
            selectedBeneficiaryName: null,
            selectedNote: null
        }
    },
    created() {
        this.loadRegistrations();
    },
    computed: {
        registrationList() {
            return this.$store.getters['events/getRegistrationList'];
        }
    },
    methods: {
        async loadRegistrations() {
            this.isLoading = true;
            try {
                await this.$store.dispatch('events/loadRegistrationList', this.id);
            } catch (error) {
                this.error = error.message || 'Something failed!';
                console.error(error.message);
            }
            this.isLoading = false;
        },
        handleRowClick(id, note, name) {
            this.showUpdateNote = true;
            this.selectedID = id;
            this.selectedNote = note;
            this.selectedBeneficiaryName = name;
        },
        toggleUpdateNote() {
            this.showUpdateNote = this.showUpdateNote ? false : true;
        },
    }
}
</script>